import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as actions from './actions';
import { SafeAttachmentPolicy } from './model';
import { initialStatus, Status } from 'projects/angular-clarity/src/app/stores/status.interface';

export const featureKey = 'exoSafeAttachmentPolicy';
export interface State extends EntityState<SafeAttachmentPolicy>, Status {}

export const adapter: EntityAdapter<SafeAttachmentPolicy> = createEntityAdapter<SafeAttachmentPolicy>({
    selectId: (entity) => entity.Identity,
});

export const initialState: State = adapter.getInitialState({
    ...initialStatus,
});

export const reducer = createReducer(
    initialState,
    on(actions.loadSafeAttachmentPolicySuccess, (state, action) =>
        adapter.setAll(action.data, { ...state, loaded: true, error: null }),
    ),
    on(actions.loadSafeAttachmentPolicyFailure, (state, { error }) => ({ ...state, error })),

    on(actions.createExoSafeAttachmentPolicy, (state) => ({ ...state, updating: true, error: null })),
    on(actions.createExoSafeAttachmentPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false, error: null }),
    ),
    on(actions.createExoSafeAttachmentPolicyFailure, (state, { error }) => ({ ...state, updating: false, error })),

    on(actions.updateExoSafeAttachmentPolicy, (state) => ({ ...state, updating: true, error: null })),
    on(actions.updateExoSafeAttachmentPolicySuccess, (state, action) =>
        adapter.upsertOne(action.data, { ...state, updating: false, error: null }),
    ),
    on(actions.updateExoSafeAttachmentPolicyFailure, (state, { error }) => ({ ...state, updating: false, error })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
